import {
    useQuery,
    UseQueryResult,
  } from "@tanstack/react-query";
  import { GetAllOrgsSitesList } from "../api";

  type GetOrgSiteListsProps = {
    authToken: string;
    leftPanelOpen?: boolean;
  };

  type Group = {
    groupName: string;
    deviceCount: number | string;
  };

  type Site = {
  siteName: string;
  siteLocation?: string;
  groups: Group[];
};

  type Org = {
  org_name: string;
  siteList: Site[]
};

  type OrgSiteList = {
    status: string;
    orgList: Org[];
  };

  export const useGetOrgSiteLists = (
    options: GetOrgSiteListsProps
  ): UseQueryResult<OrgSiteList, Error> => {
    const { authToken, leftPanelOpen } = options;
    return useQuery({
      queryKey: ["getOrgSiteLists"],
      queryFn: ({ queryKey }) => GetAllOrgsSitesList(authToken),
      enabled:
        leftPanelOpen === undefined
          ? !!authToken
          : !!authToken && leftPanelOpen,
      staleTime: 0,
      notifyOnChangeProps: "all",
    });
  };
